import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import { tracked } from '@glimmer/tracking';
import { getOwner } from '@ember/application';

var _class, _descriptor, _descriptor2;
const listKeyOf = controller => {
  const model = controller?.model;
  return model?.modelName ? `${model.modelName}:${model.documentType ?? ''}` : null;
};
const runsNoSearch = q => typeof q === 'string' && q.length > 0 && q.length < 3 && isNaN(q);

// Any `<stat>Change` key reads as a change: the shell only tells the tiles that a comparison line will exist.
const SHELL_CHANGE = Object.freeze({
  change: '0',
  className: 'text-neutral'
}); // calculateChange() shape
const ANY_CHANGE = new Proxy({}, {
  get: (target, key) => String(key).endsWith('Change') ? SHELL_CHANGE : undefined
});

/**
 * Stats placeholder of a list just entered: no figures (the tiles show bars while unsettled), only the SHAPE —
 * the comparison line exists iff this query has a comparable period (same test the stats task runs). Lazy getters:
 * the default period reaches the controller after activateForListRoute, so the test runs at render time. The
 * previous list's stats gave the wrong shape (Fatture with a period → Ricevute «tutti i periodi»: a line too many).
 */
function statsShell(service, remembered) {
  // the shape this list had last time wins: its default period is applied only after the first render
  const comparable = () => {
    if (typeof remembered === 'boolean') return remembered;
    try {
      return !!service._canCompareWithPreviousPeriod?.(service._buildQuery?.() ?? {});
    } catch {
      return false;
    }
  };
  return {
    get previousPeriod() {
      return comparable() ? {} : undefined;
    },
    get statsComparison() {
      return comparable() ? ANY_CHANGE : undefined;
    }
  };
}
let ListSwitch = (_class = class ListSwitch {
  constructor() {
    this.key = null;
    this.shapes = new Map();
    // list key → it showed a comparison line (previousPeriod) when it was left
    _initializerDefineProperty(this, "waitingSince", _descriptor, this);
    // searchItem.last at the switch; null = settled
    _initializerDefineProperty(this, "enteredWith", _descriptor2, this);
  }
  // searchItem.last at the latest enter (any list, same one too); null = no wait

  /** Called by index-context.activateForListRoute with the new list's controller. */
  enter(service, controller) {
    this.enteredWith = runsNoSearch(controller?.q) ? null : {
      last: service.searchItem?.last ?? null
    };
    const key = listKeyOf(controller);
    if (key === this.key) return;
    if (this.key) this.shapes.set(this.key, !!service.stats?.previousPeriod);
    this.key = key;
    if (!getOwner(service)?.lookup('service:ui')?.isNuova) return;
    service.items = [];
    service.stats = statsShell(service, this.shapes.get(key));
    this.waitingSince = runsNoSearch(controller?.q) ? null : {
      last: service.searchItem?.last ?? null
    };
  }

  /**
   * True once a search started after the last enter() has finished — rows, stats and SdI deadlines included (the
   * search task awaits them). For per-visit data that the search loads and resets on leave.
   */
  searchedSinceEnter(service) {
    if (!this.enteredWith) return true; // a short `q` runs no search: nothing to wait for
    const last = service.searchItem?.last;
    return !!last && last !== this.enteredWith?.last && !!last.isFinished;
  }

  /** True once a search started after the switch has finished (always true in the classic UI). */
  settled(service) {
    if (!this.waitingSince) return true;
    const last = service.searchItem?.last;
    return !!last && last !== this.waitingSince.last && !!last.isFinished;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "waitingSince", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "enteredWith", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);

export { ListSwitch as default, listKeyOf, statsShell };
//# sourceMappingURL=index-list-switch.js.map
